import { getCountryViewport } from '../geoLocation';

const partners = {
  runners_world_gb: 'runners_world_gb',
  runners_world_us: 'runners_world_us',
};

const partnerConfigs = {
  [partners.runners_world_gb]: {
    defaultSearch: {
      sport: 3,
      ...getCountryViewport('gb'),
    },
    website: 'https://www.runnersworld.com/uk/',
  },
  [partners.runners_world_us]: {
    defaultSearch: {
      sport: 3,
      ...getCountryViewport('us'),
    },
    website: 'https://www.runnersworld.com',
  },
};

export const isPartnerSession = (request) => {
  const query = (request && request.query) || {};
  const utmSource = query.utm_source;

  return utmSource && partners[utmSource];
};

export const getPartnerDefaultSearchQuery = (partnerId) => {
  return (
    partnerId &&
    partnerConfigs[partnerId] &&
    partnerConfigs[partnerId].defaultSearch
  );
};

export const getPartnerWebsite = (partnerId) => {
  return (
    partnerId && partnerConfigs[partnerId] && partnerConfigs[partnerId].website
  );
};
